import { createListenerMiddleware } from '@reduxjs/toolkit';
import { navigateToThunk } from '../../core/navigation/navigationSlice.js';
import { dynamicMiddleware } from '../../index.js';
const routes = {
    login: '/candidate/login',
    registration: '/candidate/register',
    registrationSuccess: '/candidate/register/success',
    resetPassword: '/candidate/password/reset',
    googleSuccess: '/candidate/google/success',
    passwordlessSuccess: '/candidate/passwordless/success',
    passwordlessInvalidForm: '/candidate/passwordless/invalid-link',
    linkedInResponsePage: '/candidate/linkedin/response',
};
const getParams = () => {
    const queryString = window.location.href.split('?')[1];
    return queryString || '';
};
const getRoute = (routeName, currentLocale) => {
    return `/${currentLocale}${routes[routeName]}?${getParams()}`;
};
let pageNavigationMiddlewareInstance;
const pageNavigationMiddlewareOptions = {
    actionCreator: navigateToThunk.fulfilled,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        const state = listenerApi.getState();
        window.location.assign(getRoute(action.payload, state.core.siteConfig.currentLocale));
    },
};
const addPageNavigationMiddleware = () => {
    dynamicMiddleware.resetMiddlewares();
    pageNavigationMiddlewareInstance = createListenerMiddleware();
    pageNavigationMiddlewareInstance.startListening(pageNavigationMiddlewareOptions);
    dynamicMiddleware.addMiddleware(pageNavigationMiddlewareInstance.middleware);
};
const pausePageNavigationMiddleware = () => {
    if (pageNavigationMiddlewareInstance) {
        pageNavigationMiddlewareInstance.stopListening(pageNavigationMiddlewareOptions);
    }
};
const resumePageNavigationMiddleware = () => {
    if (pageNavigationMiddlewareInstance) {
        pageNavigationMiddlewareInstance.startListening(pageNavigationMiddlewareOptions);
    }
};
export const pageNavigationMiddleware = {
    add: addPageNavigationMiddleware,
    pause: pausePageNavigationMiddleware,
    resume: resumePageNavigationMiddleware,
};
//# sourceMappingURL=pageNavigationMiddleware.js.map